import axios from './axios.service'

const method = 'contact'

class ContactService {
  async index(queryData, language) {
    try {
      const response = await axios.get(`/${method}`, {
        params: { ...queryData }
      })
      return response.data
    } catch (error) {
      return error
    }
  }

  async show(id) {
    try {
      const response = await axios({
        method: 'get',
        url: `/${method}/${id}`
      })
      return response
    } catch (error) {
      console.log(error)
    }
  }

  async delete(rowClicked) {
    try {
      const response = await axios.delete(`/${method}/${rowClicked.id}`)
      return response
    } catch (error) {
      return error
    }
  }

  async forceDelete(id, data) {
    try {
      const response = await axios.delete(`/lgpd/${method}/${id}`, {
        params: { ...data }
      })
      return response
    } catch (error) {
      return error
    }
  }
}

export default new ContactService()
